/* eslint camelcase: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromJS } from 'immutable';
import validatejs from 'validate.js';
import { Col, Row } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import Delete from 'material-ui/svg-icons/action/delete';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';

import { green400, red400 } from 'material-ui/styles/colors';

import { Field, FieldArray, formValueSelector, reduxForm, submit } from 'redux-form/immutable';

import { Checkbox, SelectField, TextField } from 'redux-form-material-ui';
import api from '../../../utils/api';
import { updateConfigurations } from '../actions';

const validate = values => {
    const errors = {};
    const membersArrayErrors = [];
    const constraints = {
        interval: {
            numericality: {
                onlyInteger: true,
                greaterThanOrEqualTo: 1,
                lessThanOrEqualTo: 60,
                message: '^Bitte geben sie einen Wert zwischen 1 und 60 ein.',
            },
        },
        email: {
            email: {
                message: '^Bitte geben Sie eine gültige E-Mail-Adresse ein',
            },
        },
    };

    const receipt_syncs = values.get('receipt_syncs') || fromJS([]);
    receipt_syncs.forEach((member, memberIndex) => {
        membersArrayErrors[memberIndex] = validatejs(member.toJS(), constraints);
    });
    errors.receipt_syncs = membersArrayErrors;

    const members = values.get('members') || fromJS([]);
    members.forEach((member, memberIndex) => {
        membersArrayErrors[memberIndex] = validatejs(member.toJS(), constraints);
    });
    errors.members = membersArrayErrors;
    return errors;
};

const newConfiguration = data_format =>
    fromJS({
        receipt_type: 'stocktaking',
        sync_type: 'email',
        data_format,
        interval: '',
        address: '',
    });

class DataFormatSettings extends Component {
    handleSubmit = () => {
        this.props.dispatch(submit('dataFormatSettings'));
    };

    componentDidMount = () => {
        this.props.getSettings();
        this.props.resetStaticApiToken();
    };

    renderConfigurations = ({ fields, meta: { touched, error }, data_format }) => {
        let labelName = 'Konfigurationen hinzufügen';
        if (fields.length > 0) {
            labelName = 'Weitere Konfigurationen hinzufügen';
        }
        return (
            <div>
                {fields
                    .map((sync, index) => {
                        let model = fields.get(index);
                        let data_format_model = model.get('data_format');
                        let successfulAt = model.get('successful_at');
                        if (successfulAt) {
                            successfulAt = moment(successfulAt).format('LLL');
                        }
                        let error = model.get('error');
                        // @todo commented out this lines for jaques
                        // if (data_format_model !== data_format && data_format_model !== '') {
                        //     return null;
                        // }
                        return (
                            <Row key={`${sync}`} style={{ marginTop: 30 }}>
                                <Col xs>
                                    <Field floatingLabelText="Belegart" name={`${sync}.receipt_type`} component={SelectField} style={{ width: '100%' }}>
                                        <MenuItem value="rearrangement" primaryText="Umlagerung" />
                                        <MenuItem value="stocktaking" primaryText="Inventur" />
                                        <MenuItem value="price_change" primaryText="Preisänderung" />
                                        <MenuItem value="customer_order" primaryText="Kundenbestellung" />
                                        <MenuItem value="retour" primaryText="Lieferantenretoure" />
                                    </Field>
                                </Col>
                                <Col xs>
                                    <Field floatingLabelText="Versandart" name={`${sync}.sync_type`} component={SelectField} style={{ width: '100%' }}>
                                        <MenuItem value="email" primaryText="E-Mail" />
                                    </Field>
                                </Col>
                                <Col xs={4}>
                                    <Field
                                        onKeyPress={event => {
                                            if (event.key === 'Enter') {
                                                this.props.updateConfigurations(this.props.receipt_syncs.push(newConfiguration(data_format)));
                                            }
                                        }}
                                        floatingLabelText="Adressen"
                                        name={`${sync}.address`}
                                        component={TextField}
                                        type="text"
                                        style={{ wjjidth: '100%' }}
                                        autoFocus={index === fields.length - 1 ? true : false}
                                    />
                                </Col>

                                <Col xs={3}>
                                    <Field
                                        floatingLabelText="Zur vollen Stunde jede N Minute(n)"
                                        name={`${sync}.interval`}
                                        component={TextField}
                                        type="number"
                                        maxValue={60}
                                        style={{ width: '100%' }}
                                    />
                                </Col>
                                <Col xs>
                                    <IconButton
                                        tooltip="SVG Icon"
                                        style={{ marginTop: '25px' }}
                                        onClick={() => {
                                            this.props.updateConfigurations(this.props.receipt_syncs.delete(index));
                                        }}>
                                        <Delete />
                                    </IconButton>
                                </Col>
                                <Col xs={12}>
                                    <Row>
                                        {(successfulAt || error) && (
                                            <Col xs={12}>
                                                <h4>Status</h4>
                                            </Col>
                                        )}
                                        {successfulAt && (
                                            <Col xs={3}>
                                                <p>Letzter erfolgreicher Versand</p>
                                                <div
                                                    style={{
                                                        backgroundColor: green400,
                                                        padding: 12,
                                                        color: '#fff',
                                                    }}>
                                                    {successfulAt}
                                                </div>
                                            </Col>
                                        )}
                                        {error && (
                                            <Col xs={6}>
                                                <p>Fehler beim letzten Versand</p>
                                                <div
                                                    style={{
                                                        backgroundColor: red400,
                                                        padding: 12,
                                                        color: '#fff',
                                                    }}>
                                                    {error}
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        );
                    })
                    .filter(n => n)}
                <Row style={{ marginTop: 20 }}>
                    <Col xs={5}>
                        <RaisedButton
                            label={labelName}
                            style={{ marginTop: '25px' }}
                            onClick={() => {
                                this.props.updateConfigurations(this.props.receipt_syncs.push(newConfiguration(data_format)));
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    render() {
        const { handleSubmit, initialValues, data_format, static_api_token } = this.props;

        return (
            <form
                onSubmit={handleSubmit}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}>
                <h2>Einstellungen</h2>
                <div>
                    <h3>Warenwirtschaftssystem</h3>
                    <Row>
                        <Col xs={12}>
                            {this.props.data_format == 'futura_ers' && (
                                <p>
                                    <strong>Hinweis zu FuturaERS</strong>: nur 3 stellige Regal-Nummern möglich!
                                </p>
                            )}
                            {this.props.data_format == 'wwscsv' && (
                                <p>
                                    <strong>Hinweis zu WWS-CSV</strong>: Beschreibung des Aufbaus für die allgemeine Schnittstelle{' '}
                                    <a href="https://docs.google.com/document/d/1xIb6BkkG6GVkFqIm3l1CmhrajDzioBrvggpIGHlvo8A">hier herunterladen</a>
                                    .
                                    <Field name="include_generic_csv_header" label="CSV-Export mit Kopfzeile" component={Checkbox} />
                                </p>
                            )}
                            {this.props.data_format == 'intersys5' && (
                                <p>
                                    <Field name="sales_person_id" component={TextField} floatingLabelText="Verkäufernummer" />
                                    <div style={{ fontSize: 12 }}>Bitte bestätigen Sie die Eingabe mit Enter</div>
                                </p>
                            )}
                            {this.props.data_format == 'h4_f3' && (
                                <p>
                                    <strong>Hinweis zu H4000 - F3000</strong>: ACHTUNG: Regalnummern max. 9 stellig
                                </p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Field name="data_format" floatingLabelText="Satzaufbau" component={SelectField}>
                                {initialValues.get('data_formats').map(setting => (
                                    <MenuItem value={setting.get('identifier')} primaryText={setting.get('name')} />
                                ))}
                            </Field>
                        </Col>
                    </Row>
                    {this.props.data_format == 'advarics' && (
                        <Row>
                            <Col md={12} sm={12} xs={12}>
                                <p>Optionale Einstellungen (nur wenn die Inventur-Belege direkt an den Advarics-Server gesendet werden sollen) - bitte erfragen Sie die Daten bei Advarics über support@advarics.net:</p>
                                <Field
                                    name="advarics_api_url"
                                    component={TextField}
                                    type="text"
                                    style={{ width: '100%' }}
                                    floatingLabelText="Advarics API Url"
                                    label="Advarics API Url"
                                />
                                <Field
                                    name="advarics_auth_key"
                                    component={TextField}
                                    type="text"
                                    style={{ width: '100%' }}
                                    floatingLabelText="Advarics API Key"
                                    label="Advarics API Key"
                                />
                            </Col>
                        </Row>
                    )}
                    <h3>Automatisierter Belegeversand</h3>
                    <p>Bitte geben Sie mehrere E-Mail-Adressen und Erfasser kommagetrennt an</p>
                    <Row>
                        <Col xs={12}>
                            <FieldArray name="receipt_syncs" component={this.renderConfigurations} data_format={data_format} />
                        </Col>
                    </Row>
                    <h3>Statischer API Token</h3>
                    <p>API Token, der von Drittanwendungen genutzt werden kann um Belege zu exportieren.</p>
                    <Row style={{ marginTop: 20 }}>
                        <Col xs={5}>
                            <RaisedButton
                                label="API Token zurücksetzen"
                                style={{ marginTop: '25px' }}
                                onClick={() => {
                                    this.props.updateStaticApiToken();
                                }}
                            />
                        </Col>
                    </Row>
                    {static_api_token !== undefined && (
                        <Row>
                            <Col>
                                <h4>Speichern sie dieses Token ab. Es wird nur einmalig angezeigt.</h4>
                            </Col>
                            <Col>
                                <p>API Token:</p>
                                <p>{static_api_token}</p>
                            </Col>
                        </Row>)}
                    <Row>
                        <RaisedButton primary label="Speichern" style={{ marginTop: '25px' }} onClick={this.handleSubmit} />
                    </Row>
                </div>
            </form>
        );
    }
}

DataFormatSettings.propTypes = {
    dispatch: PropTypes.func.isRequired,
    data_format: PropTypes.string,
    static_api_token: PropTypes.string,
};

const selector = formValueSelector('dataFormatSettings'); // <-- same as form name

const mapStateToProps = (state, props) => (
    console.log("state", state),
    console.log("static_api_token", state.user.get('static_api_token')),
    {
    data_format: selector(state, 'data_format'),
    receipt_syncs: selector(state, 'receipt_syncs'),
    static_api_token: state.settings.get('static_api_token'),
    }
);

const mapDispatchToProps = dispatch => ({
    getSettings: payload => dispatch(api.actions.settings.get(payload)),
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({ form: 'dataFormatSettings', enableReinitialize: true, validate })(DataFormatSettings));
